export default __webpack_public_path__ + "static/media/logo_web1.19d3467c.svg";